export default "__VITE_PUBLIC_ASSET__b3373f01__"